import { _request, APIBaseResponse, APIMethod } from '..';

const REPORTS_TENANTS_PATH_PREFIX = '/reports/tenants';
const USERS_ACCESS_BY_ACL_PATH = 'allusersaccessbyacl';

export interface UsersAccessByAclReportEntry {
    userId: string;
    firstName: string;
    lastName: string;
    email: string;
    licenseBillingRecord: string;
    aclResourceDisplayName: string;
    aclResourceName: string;
    userGroupName: string;
    aclStatus: string;
    userStatus: string;
    licenseStartDate?: string;
    licenseEndDate?: string;
    aclStartDate?: string;
    aclEndDate?: string;
    userTenantMembershipStartDate: string;
    userTenantMembershipEndDate?: string;
}

export interface UsersAccessByAclReportRequest {
    includeInactive: boolean;
    resourcesIds: string[];
}

export type UsersAccessByAclReportResponse = APIBaseResponse<UsersAccessByAclReportEntry[]>;

type APIUsersAccessByAclParams = {
    tenantId: string;
    request: UsersAccessByAclReportRequest;
    signal?: AbortSignal;
};

export const APIUsersAccessByAcl: APIMethod<APIUsersAccessByAclParams, UsersAccessByAclReportResponse> =
    ({ tenantId, request, signal }) =>
        _request(
            'POST',
            `${REPORTS_TENANTS_PATH_PREFIX}/${tenantId}/${USERS_ACCESS_BY_ACL_PATH}`,
            request,
            signal
        );
